<template>
  <div class="finance-page">
    <h3 class="text-center mb-4 mt-4">财务管理</h3>

    <!-- 账户总览 -->
    <a-card class="summary-card" bordered>
      <div class="summary-main">
        <div class="summary-main-label">余额（￥）</div>
        <div class="summary-main-value">
          <span class="summary-main-amount">{{ formatAmount(summary.balance) }}</span>
          <!-- <a-button type="primary" size="small" class="recharge-btn" @click="handleRecharge">
            充值
          </a-button> -->
        </div>
      </div>
      <a-row :gutter="24" class="summary-extra mt-4">
        <a-col :span="6">
          <div class="summary-item">
            <div class="summary-item-label">
              总消费（￥）
              <help-tooltip class="ml-1" :text="`含累计优惠 ￥${formatAmount(summary.totalUsedCoupon)}`" />
            </div>
            <div class="summary-item-value">{{ formatAmount(summary.totalConsume) }}</div>
          </div>
        </a-col>
        <a-col :span="6">
          <div class="summary-item">
            <div class="summary-item-label">实际消费（￥）</div>
            <div class="summary-item-value">{{ formatAmount(summary.totalPaid) }}</div>
          </div>
        </a-col>
        <a-col :span="6">
          <div class="summary-item">
            <div class="summary-item-label">累计充值（￥）</div>
            <div class="summary-item-value">{{ formatAmount(summary.totalRecharge) }}</div>
          </div>
        </a-col>
        <a-col :span="6">
          <div class="summary-item">
            <div class="summary-item-label">累计提现（￥）</div>
            <div class="summary-item-value">{{ formatAmount(summary.totalRefund) }}</div>
          </div>
        </a-col>
        <!-- <a-col :span="6">
          <div class="summary-item">
            <div class="summary-item-label">冻结金额（￥）</div>
            <div class="summary-item-value">{{ formatAmount(summary.frozenAmount) }}</div>
          </div>
        </a-col>
        <a-col :span="6">
          <div class="summary-item">
            <div class="summary-item-label">赠送金额（￥）</div>
            <div class="summary-item-value">{{ formatAmount(summary.giftAmount) }}</div>
          </div>
        </a-col>
        -->
      </a-row>
    </a-card>

    <!-- 列表区域 -->
    <a-card class="list-card mt-4" bordered>
      <a-tabs v-model="activeTab">
        <a-tab-pane key="orders" tab="订单">
          <accounted-bill-list
            :id="'finance-orders-paid'" />
        </a-tab-pane>
        <a-tab-pane key="recharge" tab="充值记录">
          <recharge-record-list
            :id="'finance-recharge-record'"
            :getParams="rechargeParams" />
        </a-tab-pane>
        <a-tab-pane key="details" tab="流水明细">
          <income-expenditure-details-list
            :id="'finance-income-expenditure'"
            :getParams="transactionParams" />
        </a-tab-pane>
        <a-tab-pane key="coupons" tab="优惠券">
          <voucher-manager-list
            :id="'finance-coupons'"
            :getParams="couponParams"
            :showGroupActions="false" />
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AccountedBillList from '@scope/views/bill-accounted/components/List'
import RechargeRecordList from '@scope/views/recharge-record/components/List'
import IncomeExpenditureDetailsList from '@scope/views/income-expenditure-details/components/List'
import VoucherManagerList from '@scope/views/voucher-manager/components/List'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'AccountBilling',
  components: {
    AccountedBillList,
    RechargeRecordList,
    IncomeExpenditureDetailsList,
    VoucherManagerList,
  },
  mixins: [WindowsMixin],
  data () {
    return {
      activeTab: 'orders',
      summary: {
        balance: 0,
        totalConsume: 0,
        totalUsedCoupon: 0,
        totalPaid: 0,
        totalRecharge: 0,
        frozenAmount: 0,
        giftAmount: 0,
      },
      rechargeParams: {
        details: true,
      },
      transactionParams: {
        details: true,
      },
      couponParams: {
        details: true,
      },
    }
  },
  computed: {
    ...mapState('app', {
      customer: state => state.customer || {},
    }),
  },
  created () {
    this.fetchSummary()
  },
  methods: {
    formatAmount (val) {
      const num = Number(val || 0)
      if (Number.isNaN(num)) return '0.00'
      return num.toFixed(2)
    },
    handleRecharge () {
      this.createDialog('RechargeAmountDialog', {
        from: 'billing',
        refresh: () => {
          this.fetchSummary()
        },
      })
    },
    async fetchSummary () {
      try {
        this.accountM = new this.$Manager('billing_accounts')
        const id = this.customer.billing_account_id
        const { data } = await this.accountM.getSpecific({ id, spec: 'balance', params: { details: true } })
        // 余额
        const balance = Number(data.balance || 0)
        // 已入账消费
        const due = Number(data.due || 0)
        // 未入账消费
        const pendingDue = Number(data.pending_due || 0)
        // 赠送金额（接口多为 gift_amount，兼容 giftAmount）
        // const giftAmount = Number(data.gift_amount || data.giftAmount || 0)
        // 已支付总原始消费
        const totalOrigin = Number(data.total_origin || 0)
        // 累计优惠
        const totalUsedCoupon = Number(data.total_used_coupon || 0)
        // 实际消费
        const totalPaid = Number(data.total_paid || 0)
        // 总充值金额
        const totalPayment = Number(data.payment || 0)
        // 总提现金额
        const totalRefund = Number(data.refund || 0)
        // 总提现中金额
        const totalRefunding = Number(data.refunding || 0)

        this.summary.balance = balance - due - pendingDue
        this.summary.totalConsume = totalOrigin
        this.summary.totalUsedCoupon = totalUsedCoupon
        this.summary.totalPaid = totalPaid
        this.summary.totalRecharge = totalPayment
        this.summary.frozenAmount = pendingDue
        // this.summary.giftAmount = coupon
        this.summary.totalRefund = totalRefund + totalRefunding
      } catch (error) {
        // 静默失败，页面展示为 0
        // eslint-disable-next-line no-console
        console.error('fetchSummary error', error)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.finance-page {
  margin: 0 auto;
  padding: 24px 24px 40px;
}

.page-subtitle {
  color: #5f6368;
  font-size: 14px;
}

.summary-card {
  border-radius: 4px;
}

.summary-main {
  text-align: left;
  .summary-main-label {
    color: #5f6368;
    font-size: 14px;
    margin-bottom: 8px;
  }
  .summary-main-value {
    display: flex;
    align-items: center;
    gap: 16px;
    .summary-main-amount {
      font-size: 40px;
      font-weight: 600;
      color: #111827;
    }
    .recharge-btn {
      margin-top: 6px;
    }
  }
}

.summary-extra {
  .summary-item {
    .summary-item-label {
      color: #5f6368;
      font-size: 13px;
      margin-bottom: 4px;
    }
    .summary-item-value {
      font-size: 18px;
      font-weight: 500;
      color: #111827;
    }
  }
}

.list-card {
  margin-top: 24px;
}
</style>
